import React, { useEffect } from "react";
import "../.././Reports.scss";
import {
    BatchVoucherReportDataType,
  TotalBatchVoucherDataType,
} from "../../../../redux/reports/reportsType";
import {
  currencySignAndNegativeValueAdjust,
  formatDate
} from "../../../../utils/commonFunctions";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";

type AppProps = {
  batchVoucherData: [] | BatchVoucherReportDataType[];
  totalBatchVoucherData: TotalBatchVoucherDataType;
  currencySign: string | undefined;
};

const BatchVoucherTableData = ({
  batchVoucherData,
  totalBatchVoucherData,
  currencySign,
}: AppProps) => {


  const returnInvoiceType = (type: number) => {
    return (
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 250 }}
        overlay={
          <Tooltip id="button-view-filter-invoice">
            {type == 1
              ? "Expense"
              : type == 2
              ? "Sales"
              : type == 3
              ? "Others"
              : "Manufacturing Journal"}
          </Tooltip>
        }
      >
        <span
          className={
            type == 1
              ? "status-incomplete"
              : type == 2
              ? "status-complete"
              : type == 3
              ? "status-pending"
              : "manufacturing-journal"
          }
          style={{
            borderRadius: "16px",
            padding: type == 4 ? "5px 8px" : "5px 10px",
          }}
        >
          {type == 1 ? "Expenses" : type == 2 ? "Sales" : type == 3 ? "Others" : "Manufacturing"}
        </span>
      </OverlayTrigger>
    );
  };

  const toFixedDecimalNumber = (data: number) => {
    return data === 0
      ? `${currencySign}0`
      : currencySignAndNegativeValueAdjust(
          currencySign,
          data ? data?.toFixed(2)?.toString() : "0"
        );
  };
  const stockItemUnit = batchVoucherData?.[0];
  const unit = stockItemUnit?.unique_quantity_code?.label?.slice(
    0,
    stockItemUnit?.unique_quantity_code?.label?.lastIndexOf("(")
  );

  const renderTotaldata = () => {
    return (
      <>
        <tr
          className="text-center"
          style={{ backgroundColor: "#d1d0cf", color: "white" }}
        >
          <td className="font-weight-bold text-dark">Total</td>
          <td></td>
          <td></td>
          <td></td>
          <td className="font-weight-bold text-dark">
            {totalBatchVoucherData?.total_inwards_qty} {""} 
            {unit}
          </td>
          <td className="font-weight-bold text-dark">
            {currencySignAndNegativeValueAdjust(
              currencySign,
              totalBatchVoucherData?.total_inwards_value
                ? totalBatchVoucherData?.total_inwards_value
                    ?.toFixed(2)
                    ?.toString()
                : "0"
            )}
          </td>
          <td className="font-weight-bold text-dark">
            {totalBatchVoucherData?.total_outwards_qty} {""}
            {unit}
          </td>
          <td className="font-weight-bold text-dark">
            {currencySignAndNegativeValueAdjust(
              currencySign,
              totalBatchVoucherData?.total_outwards_value
                ? totalBatchVoucherData?.total_outwards_value
                    ?.toFixed(2)
                    ?.toString()
                : "0"
            )}
          </td>
          <td></td>
          <td></td>
          {/* <td></td> */}
          {/* <td></td> */}
        </tr>
      </>
    );
  };
  const renderdata = () => {
    const batchVoucherTableData = batchVoucherData?.map((e: any) => {
      return (
        <>
          <tr className="text-center" key={e.date_of_invoice}>
            <td className="min-width">{formatDate(e.date_of_invoice)}</td>
            <td style={{ whiteSpace: "nowrap" }}>
                <span style={{ cursor: "pointer" }}>{e.ledger_name}</span>
            </td>
            <td style={{ minWidth: "100px" }}>
              {returnInvoiceType(e.invoice_type)}
            </td>
            <td style={{ maxWidth: "80px" }}>
              {e.invoice_number}
            </td>
            <td className="text-nowrap" style={{ color: "#2080F6" }}>
              {e.inwards_qty}{" "}
              {e?.unique_quantity_code?.label?.slice(
                0,
                e?.unique_quantity_code?.label?.lastIndexOf("(")
              )}
            </td>
            <td
              className="min-width"
              style={{ color: "#2080F6", minWidth: "150px" }}
            >
              {toFixedDecimalNumber(e.inwards_value)}
            </td>
            <td className="text-nowrap" style={{ color: "#7fb913" }}>
              {e.outwards_qty}{" "}
              {e?.unique_quantity_code?.label?.slice(
                0,
                e?.unique_quantity_code?.label?.lastIndexOf("(")
              )}
            </td>
            <td
              className="min-width"
              style={{ color: "#7fb913", minWidth: "150px" }}
            >
              {toFixedDecimalNumber(e.outwards_value)}
            </td>
            <td className="text-nowrap">
              {e.closing_qty}{" "}
              {e?.unique_quantity_code?.label?.slice(
                0,
                e?.unique_quantity_code?.label?.lastIndexOf("(")
              )}
            </td>
            <td className="min-width" style={{ minWidth: "150px" }}>
              {toFixedDecimalNumber(e.closing_value)}
            </td>
          </tr>
        </>
      );
    });
    return batchVoucherTableData;
  };
  return (
    <>
      {renderdata()}
      {renderTotaldata()}
    </>
  );
};

export default BatchVoucherTableData;
